
import styled from 'styled-components';

export const Label = styled.label`
font-family: Arial;
  color: #666666;
  margin-bottom: 4px;
`;
